import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRectangleRoundFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "scale(1.2)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M3.33337 10C3.33337 8.61929 4.45266 7.5 5.83337 7.5H14.1667C15.5474 7.5 16.6667 8.61929 16.6667 10C16.6667 11.3807 15.5474 12.5 14.1667 12.5H5.83337C4.45266 12.5 3.33337 11.3807 3.33337 10Z",
			fill: "currentColor"
		})
	})
});
export default SvgRectangleRoundFill;
